import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=dd0d33be&scoped=true"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0d33be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd0d33be')) {
      api.createRecord('dd0d33be', component.options)
    } else {
      api.reload('dd0d33be', component.options)
    }
    module.hot.accept("./supplier.vue?vue&type=template&id=dd0d33be&scoped=true", function () {
      api.rerender('dd0d33be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Produce/rmcProPurchaseQty/supplier.vue"
export default component.exports